import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Pagination,
  TableRow,
} from "@mui/material";
import { LangConstant } from "const";
import dayjs from "dayjs";

const SystemErrorTable = ({ classes, limitation, page, setPage, branchErrors }) => {
  const { t: getLabel } = useTranslation();

  const tableErrorObj = getLabel(LangConstant.OBJ_TABLE_ERROR, { returnObjects: true });

  const tableHeaderField = [
    { label: tableErrorObj.number, width: "10%" },
    { label: tableErrorObj.errorFeature, width: "20%" },
    { label: tableErrorObj.errorComponent, width: "20%" },
    { label: tableErrorObj.time, width: "15%" },
    { label: tableErrorObj.description, width: "35%" },
  ];

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const handleConvertTime = timestamp => {
    try {
      return dayjs(timestamp).format("DD/MM/YYYY HH:mm");
    } catch (error) {
      return "";
    }
  };

  return (
    <Box>
      <Paper className={classes.tableContainer}>
        <TableContainer sx={{ height: "550px" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className={classes.tableRow}>
                {tableHeaderField.map(item => (
                  <TableCell key={item.label} sx={{ width: item.width }}>
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {branchErrors.data && branchErrors.data.length > 0 ? (
                branchErrors.data.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className={classes.tableCell}>{(page - 1) * limitation + (index + 1)}</TableCell>
                      <TableCell className={classes.tableCell}>{item.error_name}</TableCell>
                      <TableCell className={classes.tableCell}>{item.component_name}</TableCell>
                      <TableCell className={classes.tableCell}>{handleConvertTime(item.created)}</TableCell>
                      <TableCell className={classes.tableCell}>{item.description}</TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <small>
                      <i>{getLabel(LangConstant.TXT_NOT_FOUND)}</i>
                    </small>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {Math.ceil(branchErrors.totalElements / limitation) > 1 && (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", margin: "24px 0" }}>
          <Pagination
            count={Math.ceil(branchErrors.totalElements / limitation)}
            page={page}
            onChange={handlePageChange}
            color="primary"
            variant="outlined"
            shape="rounded"
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </Box>
  );
};

export default memo(SystemErrorTable);
